import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { KYMW7003Component } from './kymw7003.component';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetFeatureRequestStatusListService } from './api-services/get-feature-request-status-list.service';

@NgModule({
  declarations: [
    KYMW7003Component
  ],
  imports: [
    WjNavModule,
    CommonModule,
    WjGridModule,
    WjGridFilterModule,
    AppCommonsModule,
  ],
  providers: [
    GetFeatureRequestStatusListService,
  ],
})
export class KYMW7003Module { }